import {UserTracker} from "../index.js";

const eventDics = {
    Profile: "mini:left-menu-profile:click", // 프로필
    Favorite: "mini:left-menu-favorite:click", // 즐겨찾기
    Project: "mini:left-menu-project:click", // 프로젝트
    Organization: "mini:left-menu-organization:click", // 조직도
    Contact: "mini:left-menu-contact:click", // 연락처
    Chatting: "mini:left-menu-chatting:click", // 채팅
    FlowMain: "mini:left-menu-flow-main:click", // 메인창
    Setting: "mini:left-menu-setting:click", // 세팅버튼
    // Memo: "mini:left-menu-memo:click", // 플로키의 메모장
    // LETTER: "mini:left-menu-letter:click", // 쪽지
    // dashboard: "mini:left-menu-dashboard:click", // 대시보드
    // Portal: "mini:left-menu-portal:click", // 포탈
    // ChatBot: "mini:left-menu-chatbot:click", // 채팅봇
    // Channel: "mini:left-menu-channel:click", // 채널?
    // SMS: "mini:left-menu-sms:click", // SMS
}

export const MiniLeftMenuTracker = () => {
    const Tracker = Object.create(UserTracker)
    Tracker.track = (eventName) => {
        const event = eventDics[eventName];
        if (!event) return;

        return Tracker.trackAction({event: event, value: null, data: {}});
    }

    return Tracker;
}